export const MODAL_TITLE = 'Change School'
export const CURRENT_SCHOOL_LABEL = 'Current School:'
export const CHANGE_SCHOOL_LABEL = 'Change to:'
export const NO_SCHOOLS_FOUND = 'No Schools Found'
export const MODAL_TEXT = `When you change your school, you’ll be redirected to the My Programs page for that school.`
